import './TournamentForm.css'
import { useState, useEffect, memo } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate, useParams, useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

import { useGetCommunityQuery, useAddTournamentMutation } from '../../redux/communityService/communityApiSlice'
import { useUpdateTournamentMutation } from '../../redux/singleTournamentService/singleTournamentApiSlice'
import Select from '../Select/Select'
import { Input } from '../Input/Input'
import { Button } from '../Button/Button'
import Textarea from '../Textarea/Textarea'
import { Header } from '../Header/Header'

const formArrayOfObjectsForSelect = (data) => {
	const arrayOfObjects = data?.map(el => {
		return {
			label: el?.name,
			value: el?.uid
		}
	})
	return arrayOfObjects
}

function TournamnetFormComponent(props) {
	dayjs.extend(customParseFormat)
	const { t } = useTranslation()
	const [addTournament] = useAddTournamentMutation()
	const [updateTournament] = useUpdateTournamentMutation()
	const { tournamentUid } = useParams()
	const communityUid = localStorage.getItem('communityUid')
	const { data = {}, error, isLoading } = useGetCommunityQuery({ community_uid: communityUid })
	const { closeEditorComponent } = props
	const navigate = useNavigate()

	// const [categories, setCategories] = useState([])
	const [venues, setVenues] = useState([])
	const [tournamentName, setTournamentName] = useState(props?.tournament?.name ? props?.tournament?.name : '')
	const [tournamentVenue, setTournamentVenue] = useState('')
	const [tournamentDate, setTournamentDate] = useState(
		props?.tournament?.start_date ?
			props?.tournament?.start_date
			:
			''
	)
	// const [tournamentCategory, setTournamentCategory] = useState("")
	const [tournamentType, setTournamentType] = useState(props?.tournament?.type ? props?.tournament?.type : 'singles')
	const [tournamentDescription, setTournamentDescription] = useState(
		props?.tournament?.description ?
			props?.tournament?.description
			:
			''
	)
	const [roundRobinRankingSystem, setRoundRobinRankingSystem] = useState(
		props?.tournament?.round_robin_ranking_system ?
			props?.tournament?.round_robin_ranking_system
			:
			'group_sets_games_win_percentage'
	)

	// const [gender, setGender] = useState(props?.tournament?.gender ? props?.tournament?.gender : "men")
	const [errName, setErrName] = useState(false)
	const [errDate, setErrDate] = useState(false)
	const [errVenue, setErrVenue] = useState(false)
	// const [errCategory, setErrCategory] = useState(false)
	const [err, setErr] = useState(false)

	useEffect(() => {
		if (Object.keys(data).length === 0) {
			return
		} else {
			// setCategories(formArrayOfObjectsForSelect(data?.categories))
			setVenues(formArrayOfObjectsForSelect(data?.venues))

			// Получили категорию турнира
			// const tournamentСategory = data?.categories?.filter(category => {
			//	return category.uid === props?.tournament?.category_uid
			// })
			// setTournamentCategory({
			//	label: tournamentСategory[0]?.name,
			//	value: tournamentСategory[0]?.uid
			// })

			// Получили место (адрес) турнира
			const tournamentVenues = data?.venues?.find(venue => {
				return venue.uid === props?.tournament?.venue_uid
			})
			setTournamentVenue({
				label: tournamentVenues?.name,
				value: tournamentVenues?.uid,
				address_string: tournamentVenues?.address_string
			})
		}
	}, [data, props?.tournament])

	const handleDateInput = (value) => {
		if(value?.length > 10){
			return
		} else {
			setTournamentDate(value)
		}
	}

	// Проверяем поля на пустоту
	const checkFields = () => {
		let err = false

		if (!tournamentName) {
			setErrName(true)
			err = true
		}

		if (!tournamentDate) {
			setErrDate(true)
			err = true
		}

		if (err) {
			return false
		} else {
			return true
		}
	}

	// Создаём новый турнир
	const handleSubmit = async (event) => {
		event.preventDefault()

		if (!checkFields()) {
			return
		}

		// Создаём новый турнир
		const body = {
			'language_code': data?.language_code,
			'name': String(tournamentName),
			'type': tournamentType,
			// 'gender': gender,
			// 'category_uid': tournamentCategory?.value ? tournamentCategory?.value : null,
			'venue_uid': tournamentVenue?.value,
			'start_date': tournamentDate,
			'description': String(tournamentDescription),
			'community_uid': data?.uid,
			'round_robin_ranking_system': roundRobinRankingSystem
		}

		try {
			const response = await addTournament(body).unwrap()

			setTournamentName('')
			setTournamentVenue('')
			setTournamentDate('')
			// setTournamentCategory('')
			setTournamentType('singles')
			setTournamentDescription('')
			setRoundRobinRankingSystem('group_sets_games_win_percentage')
			// setGender("none")

			navigate(`/${response?.uid}`)
			closeEditorComponent()

		} catch (e) {
			console.log('addTournaments catched error', e)

			setErr(true)
		}

		closeEditorComponent()
	}

	// Редактируем уже созданный турнир
	const handleEditSubmit = async (event) => {
		event.preventDefault()

		const tournament = { ...props?.tournament }

		const body = {
			...tournament,
			'name': String(tournamentName),
			'type': tournamentType,
			// 'gender': gender,
			// 'category_uid': tournamentCategory?.value,
			'venue_uid': tournamentVenue?.value,
			'start_date': tournamentDate,
			'description': String(tournamentDescription),
			'community_uid': data?.uid,
			'round_robin_ranking_system': roundRobinRankingSystem
		}

		try {
			const response = await updateTournament({
				community_uid: communityUid,
				tournament_uid: tournamentUid,
				body
			})

			closeEditorComponent()
		}
		catch (e) {
			console.log('updateTournament catched error', e)
		}
	}

	if (isLoading) { return <h1>Loading</h1> }
	if (error) { console.log(error) }

	return (
		<>
			{
				props?.header &&
					<Header
						backButton={true}
						title={data?.name}
						subtitle={t('Tournament creation')}
					/>
			}

			<div className="tournamentform-wrapper">
				<div className="tournamentform-container">
					<form className="tournamentform-form">
						<div className="form-input">
							<label className="input__label">
								{t('Name')} <span style={{ color: 'red' }}>*</span>
							</label>

							<Input
								onChange={(e) => setTournamentName(e.target.value)}
								onClick={() => setErrName('')}
								type="text"
								borderColor={errName ? '#F20505' : ''}
								required={false}
								value={tournamentName}
							/>

							{
								errName &&
									<p className="tournamentform__error">
										{t('Enter name')}
									</p>
							}
						</div>

						<div className="form-select">
							<label className="select__label">
								{t('Venue')}
							</label>

							<Select
								onChange={(choice) => setTournamentVenue(choice)}
								onClick={() => setErrVenue('')}
								options={venues}
								err={errVenue}
								defaultValue={tournamentVenue}
							/>

							{
								errVenue &&
									<p className="tournamentform__error">
										{t('Choose venue')}
									</p>
							}
						</div>

						<div className="form-input">
							<label className="input__label">
								{t('Tournament start date')} <span style={{ color: 'red' }}>*</span>
							</label>

							<input
								value={tournamentDate}
								onChange={(e) => handleDateInput(e.target.value)}
								onClick={() => setErrDate(false)}
								type="date"
								className="form__input-date"
								style={{ border: errDate ? '1px solid red' : '' }}
							/>

							{
								errDate &&
									<p className="tournamentform__error">
										{t('Enter date')}
									</p>
							}
						</div>

						{/* <div className="form-select">
							<label className="select__label">
								{t("Tournament category")}
							</label>

							<Select
								onChange={(choice) => setTournamentCategory(choice)}
								onClick={() => setErrCategory(false)}
								options={categories}
								err={errCategory}
								defaultValue={tournamentCategory}
							/>

							{
								errCategory &&
									<p className="tournamentform__error">
										{t("Choose category")}
									</p>
							}
						</div> */}

						<div className="form__inputs-radio">
							<p className="inputs-radio__title">{t('Type')}</p>

							<div className="inputs-radio__container">
								<input
									id="radio-single"
									type="radio"
									name="type"
									value="singles"
									checked={tournamentType === 'singles'}
									onChange={() => setTournamentType('singles')}
									className="inputs-radio__button"
								/>

								<label htmlFor="radio-single">
									{t('Single tournament')}
								</label>
							</div>

							<div className="inputs-radio__container">
								<input
									id="radio-double"
									type="radio"
									name="type"
									value="doubles"
									checked={tournamentType === 'doubles'}
									onChange={() => setTournamentType('doubles')}
									className="inputs-radio__button"
								/>

								<label htmlFor="radio-double">
									{t('Double tournament')}
								</label>
							</div>
						</div>

						{/* <div className="form__inputs-radio">
							<p className="inputs-radio__title">
								{t("Gender")}
							</p>

							<div className="inputs-radio__container">
								<input
									id="radio-men"
									type="radio"
									name="gender"
									value="men"
									onChange={() => setGender("men")}
									className="inputs-radio__button"
									checked={gender === 'men'}
								/>

								<label htmlFor="radio-men">
									{t("Men")}
								</label>
							</div>

							<div className="inputs-radio__container">
								<input
									id="radio-women"
									type="radio"
									name="gender"
									value="women"
									onChange={() => setGender("women")}
									className="inputs-radio__button"
									checked={gender === 'women'}
								/>

								<label htmlFor="radio-women">
									{t("Women")}
								</label>
							</div>

							{
								tournamentType === "singles" &&
								<div className="inputs-radio__container">
									<input
										id="radio-other"
										type="radio"
										name="gender"
										value="other"
										onChange={() => setGender('other')}
										className="inputs-radio__button"
										checked={gender === 'other'}
									/>

									<label htmlFor="radio-other">
										{t("Other")}
									</label>
								</div>
							}

							{
								tournamentType === "doubles" &&
								<div className="inputs-radio__container">
									<input
										id="radio-mix"
										type="radio"
										name="gender"
										value="mixed"
										onChange={() => setGender("mixed")}
										className="inputs-radio__button"
										checked={gender === 'mixed'}
									/>

									<label htmlFor="radio-mix">
										{t("Mixed")}
									</label>
								</div>
							}
						</div> */}

						<div className="form-select">
							<label className="select__label">
								{t('Tournament description')}
							</label>

							<Textarea
								value={tournamentDescription}
								onChange={(e) => setTournamentDescription(e.target.value)}
								height={'150px'}
							/>
						</div>

						<div className="form__block-addition">
							<p className="form__block-addition__title">
								{t('Additional settings')}
							</p>

							<div className="block-addition__container">
								<p className="block-addition__container-title">
									{t('A method for determining places in a round-robin group when several participants have equal points')}
								</p>

								<div className="inputs-radio__container">
									<input
										id="radio-persentage--first"
										name="percentage"
										type="radio"
										value={'group_sets_games_win_percentage'}
										onChange={(e) => setRoundRobinRankingSystem(e.target.value)}
										className="inputs-radio__button"
										checked={
											roundRobinRankingSystem === 'group_sets_games_win_percentage'
										}
									/>

									<label htmlFor="radio-persentage--first">
										{t('By the percentage of all sets/games won')}
									</label>
								</div>

								<div className="inputs-radio__container">
									<input
										id="radio-persentage--second"
										name="percentage"
										type="radio"
										value={'equal_match_points_sets_games_win_percentage'}
										onChange={(e) => setRoundRobinRankingSystem(e.target.value)}
										className="inputs-radio__button"
										checked={
											roundRobinRankingSystem === 'equal_match_points_sets_games_win_percentage'
										}
									/>

									<label htmlFor="radio-persentage--second">
										{t('By the percentage of sets/games won in games with each other')}
									</label>
								</div>
							</div>

							{
								err &&
									<p className="tournamentform__main-error">
										{t('Something went wrong. Try later please')}
									</p>
							}

							{
								!props?.edit ?
									<div className="form-submit">
										<Button type={'submit'} title={t('Create')} onClick={handleSubmit} />
									</div>
									:
									<div className="form-submit">
										<Button type={'submit'} title={t('Save')} onClick={handleEditSubmit} />
									</div>
							}
						</div>
					</form>
				</div>
			</div>
		</>
	)
}

export const TournamentForm = memo(TournamnetFormComponent)